// Navigation utility with scroll to top
export const navigateWithScroll = (navigate, path) => {
  navigate(path);
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 100);
};
